export default __webpack_public_path__ + "static/media/33.472a9343.jpg";